'use es6';

import isArray from 'hs-lodash/isArray';
const TIMEOUT_MIN_MS = 0;
const TIMEOUT_MAX_MS = 60000;
export function validateClient(client, caller) {
  if (!client || typeof client !== 'object' || typeof client.resolve !== 'function' || typeof client.logExposure !== 'function' || typeof client.logExposures !== 'function') {
    throw new Error(`laboratory-lib "${caller}" expected "client" to be available with these method(s) ["resolve", "logExposure", "logExposures"].`);
  }
}
export function validateCallback(callback, caller, example) {
  if (!callback || typeof callback !== 'function') {
    throw new Error(`laboratory-lib "${caller}" expected a callback argument. Example usage: "${example})"`);
  }
}
export function validateSearch(search, caller) {
  if (typeof search !== 'string') {
    throw new Error(`laboratory-lib "${caller}" expected "search" to be a string. Received "${typeof search}".`);
  }
}
export function validateStore(store, caller) {
  if (store && (typeof store.get !== 'function' || typeof store.set !== 'function' || typeof store.delete !== 'function')) {
    throw new Error(`laboratory-lib "${caller}" expected "store" to be a SuperStore instance implementing each of these method(s) ["get", "set", "delete"].`);
  }
}
export function validateTreatmentOrKeys(treatmentOrKeys, caller) {
  if (!treatmentOrKeys || !isArray(treatmentOrKeys)) {
    throw new Error(`laboratory-lib "${caller}" expects to be provided with an array of either treatment keys, or a treatment objects.`);
  }

  treatmentOrKeys.forEach(treatmentOrKey => {
    const keyMode = typeof treatmentOrKey === 'string';

    if (!treatmentOrKey) {
      throw new Error(`laboratory-lib "${caller}" expects all treatments or keys to be non-empty.`);
    } else if (!keyMode && (!treatmentOrKey.key || !treatmentOrKey.identifier)) {
      throw new Error(`laboratory-lib "${caller}" expects all treatments to contain the following properties. ["key", "identifier"].`);
    }
  });
}
export function validateTreatmentsSchema(treatments, caller) {
  if (!treatments || typeof treatments !== 'object') {
    throw new Error(`laboratory-lib "${caller}" expected "treatments" to be a non-empty array.`);
  }

  Object.keys(treatments).forEach(k1 => {
    const treatment = treatments[k1];

    if (!treatment || typeof treatment !== 'object' || !treatment.identifier || !treatment.parameters) {
      throw new Error(`laboratory-lib "${caller}" expected treatments to be an object containing each of these properties ["identifier", "parameters"]. Treatment: "${k1}"`);
    }

    if (treatment.maxAge && (typeof treatment.maxAge !== 'number' || treatment.maxAge < 0)) {
      throw new Error(`laboratory-lib "${caller}" expected treatment maxAge to be a number greater than 0. Treatment: "${k1}"`);
    }

    if (typeof treatment.parameters !== 'object') {
      throw new Error(`laboratory-lib "${caller}" expected treatment parameters to be of the shape Object<String, Array>. Treatment: "${k1}"`);
    }

    Object.keys(treatment.parameters).forEach(k2 => {
      if (!isArray(treatment.parameters[k2]) || !treatment.parameters[k2].length) {
        throw new Error(`laboratory-lib "${caller}" expected parameters options to be a non-empty array. Treatment: "${k1}", Parameter: "${k2}"`);
      }
    });
  });
}
export function validateHttp(http, caller) {
  if (!http || typeof http.post !== 'function' || typeof http.get !== 'function') {
    throw new Error(`laboratory-lib "${caller}" expected "http" to be a hub-http client implementing each of these method(s) ["get", "post"].`);
  }
}
export function validateTimeout(timeout, caller) {
  if (isNaN(timeout) || timeout < TIMEOUT_MIN_MS || timeout > TIMEOUT_MAX_MS) {
    throw new Error(`laboratory-lib "${caller}" expected "timeout" to be set between ${TIMEOUT_MIN_MS} - ${TIMEOUT_MAX_MS} milliseconds.`);
  }
}
export function validateQuickFetch(quickFetch, caller) {
  if (!quickFetch || typeof quickFetch !== 'object' || typeof quickFetch.getRequestStateByName !== 'function') {
    throw new Error(`laboratory-lib "${caller}" expected "window.quickFetch" to be available with these method(s) ["getRequestStateByName"].`);
  }
}
export function validateQuickFetchLabel(quickFetchLabel, caller) {
  if (!quickFetchLabel || typeof quickFetchLabel !== 'string') {
    throw new Error(`laboratory-lib "${caller}" expected "quickFetchLabel" to be a non-empty string.`);
  }
}